export const resolveCreatedStartBound = ({
  createdStartDate,
  createdSince,
}: {
  createdStartDate: Date | null;
  createdSince: Date | null;
}): Date | null => {
  if (createdStartDate === null || createdSince === null) {
    return createdSince ?? createdStartDate;
  }

  return createdSince > createdStartDate ? createdSince : createdStartDate;
};
